<template>
  <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
import FormBuilder from "../../FormBuilder.vue"


export default {
  components: {
    FormBuilder
  },
  props: {
    formValue: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: [
        {
          title: "Dosage Forms",
          anchor: "1.1",
          description: "Create \"Dosage Form\"",
          forms: [
            {
              label: "Dosage forms",
              type: "sectionarray",
              value: "dosageForms",
              grid: "grid-50w",
              buttonText: "New dosage form",
              forms: [{
                type: "guid",
                value: "id"
              }, {
                type: "text",
                label: "Name",
                value: "name",
                required: true
              }, {
                type: "select",
                label: "Type",
                value: "type.value.name",
                preValues: "studyDosageForms",
                required: true
              }, {
                type: "number",
                label: "Quantity",
                helper: "If the Dosage Form type is a solution, liquid or similar the quantity should be \"1\"",
                value: "type.quantity",
                required: true
              }, {
                type: "select",
                label: "Unit",
                placeholder: "",
                helper: "If the Dosage Form type is a solution, liquid or similar please select \"Unit\"",
                value: "type.unit.name",
                preValues: "studyUnits",
                required: true
              }, {
                type: "section",
                label: "API",
                extraClass: "grid-full",
                forms: [{
                  type: "text",
                  label: "Name",
                  value: "activeIngredient.value.name",
                  extraClass: "grid-full"
                }, {
                  type: "number",
                  label: "Amount of api in dosage form",
                  value: "activeIngredient.quantity"
                }, {
                  type: "select",
                  label: "Units of measure",
                  value: "activeIngredient.unit.name",
                  preValues: "studyUnits"
                }, {
                  type: "section",
                  label: "API cost",
                  extraClass: "grid-full white",
                  forms: [{
                    type: "number",
                    label: "Cost per unit",
                    value: "activeIngredient.value.cost.price",
                    inline: "{currency}"
                  }, {
                    type: "select",
                    label: "Unit",
                    value: "activeIngredient.value.cost.unit.name",
                    preValues: "studyUnits"
                  }]
                }]
              }],
              callback: this.handleDeletedDosageForm
            },
          ]
        }, {
          title: "Primary Packaging",
          anchor: "1.2",
          description: "Create \"Primary Packaging\" and associate \"Dosage Form\"",
          forms: [
            {
              label: "Primary Packaging",
              type: "sectionarray",
              value: "primaryPackages",
              grid: "grid-50w",
              buttonText: "New Primary Packaging",
              forms: [{
                type: "text",
                label: "Name",
                value: "name",
                required: true
              }, {
                type: "datalist",
                label: "Packaging type",
                value: "value.packagedMatrial",
                preValues: "studyPackaging",
                required: true
              }, {
                type: "guid",
                value: "id"
              }, {
                type: "section",
                label: "Associate dosage form",
                extraClass: "grid-full",
                forms: [{
                  type: "select",
                  label: "Dosage form",
                  value: "value.dosageFormId",
                  preValues: {
                    "field": "dosageForms",
                    "name": "name",
                    "value": "id"
                  },
                  required: true
                }, {
                  type: "number",
                  label: "Quantity",
                  value: "value.dosageFormQuantity",
                  helper: "Please enter the quantity of Dosage Form in the Primary Packaging.",
                  required: true
                }]
              }]
            },
          ]
        }, {
          title: "Secondary Packaging",
          anchor: "1.3",
          description: "Create \"Secondary\" and associate \"Primary Packaging\"",
          forms: [
            {
              label: "Secondary Packaging",
              type: "sectionarray",
              value: "secondaryPackages",
              grid: "grid-50w",
              buttonText: "New Secondary Packaging",
              forms: [{
                type: "guid",
                value: "id",
              }, {
                type: "text",
                label: "Name",
                value: "name",
                required: true
              }, {
                type: "datalist",
                label: "Packaging type",
                value: "packagingType",
                preValues: "studyPackaging",
                required: true
              }, {
                type: "section",
                label: "Associate Primary Packaging",
                extraClass: "grid-full",
                helper: "Combine primary packaging to create a secondary packaging (labeled unit)",
                grid: "grid-50w",
                forms: [{
                  type: "select",
                  label: "Primary Packaging",
                  value: "primaryPackageId",
                  preValues: {
                    "field": "primaryPackages",
                    "name": "name",
                    "value": "id"
                  },
                  required: true
                }, {
                  type: "number",
                  label: "Quantity",
                  value: "primaryPackageQuantity",
                  helper: "Please enter the quantity of Primary Packaging in the Secondary Packaging.",
                  required: true
                }]
              }]
            },
          ]
        }, {
          title: "Dispensing Units",
          anchor: "1.4",
          description: "Create \"Dispensing Units\" and associate \"Secondary Packaging\"",
          forms: [
            {
              label: "Dispensing Units",
              type: "sectionarray",
              value: "dispensingUnits",
              grid: "grid-50w",
              buttonText: "New Dispensing Unit",
              callback: this.handleDeletedDispensingUnit,
              forms: [{
                type: "guid",
                value: "id"
              }, {
                type: "text",
                label: "Name",
                value: "name",
                required: true
              }, {
                type: "number",
                label: "Cost per DUN",
                value: "cost",
                inline: "{currency}",
                helper: "Packaging and labeling cost per Dispensing Unit"
              }, {
                type: "text",
                label: "Do Not Dispense",
                value: "doNotDispense",
                inline: "Days",
                required: true
              },
                {
                  type: "number",
                  label: "Do Not Count",
                  value: "doNotCount",
                  inline: "Days",
                  required: true
                },
                {
                  type: "sectionarray",
                  label: "Associate Secondary Packaging",
                  extraClass: "grid-full",
                  grid: "grid-50w",
                  buttonText: "Associate Secondary Packaging",
                  value: "secondaryPackages",
                  helper: "Combine packaged material to create a shippable dispensing unit",
                  forms: [{
                    type: "select",
                    label: "Secondary Packaging",
                    value: "secondaryPackages",
                    preValues: {
                      "field": "secondaryPackages",
                      "name": "name",
                      "value": "id"
                    }
                  }, {
                    type: "number",
                    label: "Quantity",
                    value: "quantity",
                    helper: "Please enter the quantity of Secondary Packaging in the Dispensing Unit."
                  }]
                }]
            },
          ]
        }, {
          title: "Ancillary Items",
          anchor: "1.5",
          description: "Create \"Ancillary item(s)\" that will be packed into one or more dispensing units",
          forms: [
            {
              label: "Ancillary Items",
              type: "sectionarray",
              value: "ancillaryEquipments",
              grid: "grid-50w",
              buttonText: "New Ancillary item",
              forms: [{
                type: "guid",
                value: "id"
              }, {
                type: "text",
                label: "Name",
                value: "name",
                required: true
              }, {
                type: "text",
                label: "Description",
                value: "description"
              }, {
                type: "section",
                label: "Costs",
                extraClass: "grid-full",
                forms: [{
                  type: "number",
                  label: "Price per unit",
                  value: "cost",
                  inline: "{currency}"
                }]
              }, {
                type: "sectionarray",
                label: "Associate to DUN",
                extraClass: "grid-full",
                grid: "grid-50w",
                value: "dispensingUnits",
                helper: "Combine ancillary items with shippable dispensing unit",
                buttonText: "Add Dispensing Unit",
                forms: [{
                  type: "number",
                  label: "Quantity",
                  value: "quantity",
                  required: true
                }, {
                  type: "select",
                  label: "Dispensing Unit",
                  value: "dispensingUnit",
                  required: true,
                  preValues: {
                    "field": "dispensingUnits",
                    "name": "name",
                    "value": "id"
                  }
                }]
              }]
            }
          ]
        }
        , {
          title: "Review Materials",
          anchor: "1.6",
          description: "Review that materials has been setup correctly.",
          forms: [{
            type: "materialreviewtable"  /* note the materialreview is a standalone component */
          }]
        }
      ]
    }
  },
  methods: {
    handleDeletedDosageForm: function (deletedDF, data, _, deleted) {
      if (!deleted)
        return;

      if (this.NullOrUndefined(data))
        return;
      
      if (this.NullOrUndefined(data.treatmentGroups))
        return;

      const treatmentGroups = data.treatmentGroups;
      for (let i = 0; i < treatmentGroups.length; i++) {
        const tg = treatmentGroups[i];

        if (this.NullOrUndefined(tg.dosageRegimens) || tg.dosageRegimens.length === 0)
          continue;
        
        const index = tg.dosageRegimens.findIndex(x => x.dosage.dosageFormReference.id === deletedDF.id)
        if (index === -1)
          continue;

        tg.dosageRegimens.splice(index, 1);
      }
    },
    cascadeCheckPackingConstraints: function (data, deletedDun) {

      if (this.NullOrUndefined(data) 
          || this.NullOrUndefined(data.shipping) 
          || this.NullOrUndefined(data.shipping.packing) 
          || this.NullOrUndefined(data.shipping.packing.constraints)) {
        return;
      }


      // Cascade across packing constraints
      const constraints = data.shipping.packing.constraints;

      if (constraints.length === 0)
        return;

      for (let i = constraints.length - 1; i >= 0; i--) {
        const constraint = constraints[i];
        for (let j = constraint.dispensingUnits.length - 1; j >= 0; j--) {
          const dun = constraint.dispensingUnits[j];
          if (dun.id !== deletedDun.id)
            continue;

          constraint.dispensingUnits.splice(j, 1);
        }

        if (constraint.dispensingUnits.length === 0) {
          constraints.splice(i, 1);
        }
      }
    },
    cascadeCheckSupplyPlans: function (data, deletedDun) {

      if (this.NullOrUndefined(data) 
          || this.NullOrUndefined(data.supplyPlans) 
          || data.supplyPlans.length === 0) {
        return;
      }

      // Cascade across supply plans
      const supplyPlans = data.supplyPlans;
      for (let i = supplyPlans.length - 1; i >= 0; i--) {
        const plan = supplyPlans[i];
        if (plan.dispensingUnit !== deletedDun.id)
          continue;

        supplyPlans.splice(i, 1);
      }

    },
    cascadeCheckSupplyChains: function (data, deletedDun) {
      // Cascade across supply chains
      if (this.NullOrUndefined(data) || this.NullOrUndefined(data.supplyChain) || data.supplyChain.length === 0) {
        return;
      }
      const supplyChains = data.supplyChain;
      for (let i = supplyChains.length - 1; i >= 0; i--) {
        const chain = supplyChains[i];
        const duns = chain.dispensingUnits;
        for (let j = duns.length - 1; j >= 0; j--) {
          if (duns[j] !== deletedDun.id)
            continue;

          duns.splice(j, 1);
        }

        if (duns.length === 0) {
          supplyChains.splice(i, 1);
        }
      }

    },
    cascadeCheckSites: function (data, deletedDun) {
      
      if (this.NullOrUndefined(data) || this.NullOrUndefined(data.sites) || data.sites.length === 0) {
        return;
      }

      // Cascade across sites
      const sites = data.sites;
      for (let i = sites.length - 1; i >= 0; i--) {
        const site = sites[i];
        const duns = site.dispensingUnits;
        for (let j = duns.length - 1; j >= 0; j--) {
          var dun = duns[j];
          if (dun.dispensingUnitReference.id !== deletedDun.id)
            continue;

          duns.splice(j, 1);
        }
      }
    },
    cascadeCheckRisk: function (data, deletedDun) {
      // Cascade across supply chains
      if (this.NullOrUndefined(data) || this.NullOrUndefined(data.risk) || data.risk.length === 0) {
        return;
      }

      // Cascade across risks
      const risks = data.risk;
      for (let i = risks.length - 1; i >= 0; i--) {
        const risk = risks[i];
        const duns = risk.dispensingUnits;
        for (let j = duns.length - 1; j >= 0; j--) {
          const dun = duns[j];
          if (dun !== deletedDun.id)
            continue;
          duns.splice(j, 1);
        }

        if (duns.length === 0) {
          risks.splice(i, 1);
        }

      }
    },
    cascadeCheckTreatmentGroups: function (data, deletedDun) {


      if (this.NullOrUndefined(data) || this.NullOrUndefined(data.treatmentGroups) || data.treatmentGroups.length === 0) {
        return;
      }

      // Cascade across Treatment Groups

      const treatmentGroups = data.treatmentGroups;
      for (let i = 0; i < treatmentGroups.length; i++) {
        const tg = treatmentGroups[i];
        const index = tg.dispensingUnits.findIndex(x => x.id === deletedDun.id);
        if (index === -1)
          continue;

        tg.dispensingUnits.splice(index, 1);

        // The TG was using the DUN, so prune the visit schedule
        const visits = tg.visitSchedule.visits;
        for (let j = visits.length - 1; j >= 0; j--) {
          const visit = visits[j];
          const configurations = visit.visitDispensingUnitConfigurations;
          for (let k = configurations.length - 1; k >= 0; k--) {
            const config = configurations[k];
            if (config.dispensingUnit !== deletedDun.id)
              continue;

            configurations.splice(k, 1);
          }

          if (configurations.length !== 0)
            continue;

          visits.splice(j, 1);
        }
      }

    },
    cascadeCheckProductionPlanned: function (data, deletedDun) {
      if (this.NullOrUndefined(data)
          || this.NullOrUndefined(data.production)
          || this.NullOrUndefined(data.production.plannedBatchs)
          || data.production.plannedBatchs.length === 0) {
        return;
      }


      // Cascade across planned batchs

      const plannedBatchs = data.production.plannedBatchs;
      for (let i = plannedBatchs.length - 1; i >= 0; i--) {
        const batch = plannedBatchs[i];
        for (let j = batch.dispensingUnits.length - 1; j >= 0; j--) {
          const dun = batch.dispensingUnits[j];
          if (dun.id !== deletedDun.id)
            continue;

          batch.dispensingUnits.splice(j, 1);
        }

        if (batch.dispensingUnits.length === 0) {
          plannedBatchs.splice(i, 1);
        }
      }

    },
    cascadeCheckProductionTemplate: function (data, deletedDun) {

      if (this.NullOrUndefined(data)
          || this.NullOrUndefined(data.production)
          || this.NullOrUndefined(data.production.batchTemplates)
          || data.production.batchTemplates.length === 0) {
        return;
      }

      // Cascade across batch templates
      const templates = data.production.batchTemplates;
      for (let i = templates.length - 1; i >= 0; i--) {
        const batch = templates[i];
        for (let j = batch.dispensingUnits.length - 1; j >= 0; j--) {
          const dun = batch.dispensingUnits[j];
          if (dun.id !== deletedDun.id)
            continue;

          batch.dispensingUnits.splice(j, 1);
        }

        if (batch.dispensingUnits.length === 0) {
          templates.splice(i, 1);
        }
      }
    },
    handleDeletedDispensingUnit: function (deletedDun, data, _, deleted) {
      if (!deleted)
        return;
      this.cascadeCheckTreatmentGroups(data, deletedDun);
      this.cascadeCheckPackingConstraints(data, deletedDun);
      this.cascadeCheckSupplyPlans(data, deletedDun);
      this.cascadeCheckSupplyChains(data, deletedDun);
      this.cascadeCheckSites(data, deletedDun);
      this.cascadeCheckRisk(data, deletedDun);
      this.cascadeCheckProductionTemplate(data, deletedDun);
      this.cascadeCheckProductionPlanned(data, deletedDun);

    }
  }

}
</script>
